import React from 'react'
import LearnerDashboard from '../../components/core/Dashboard/LearnerDashboard/LearnerDashboard'

export function LearnerApp() {
  return <LearnerDashboard />
}

export default LearnerApp
